// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"17":"f776709ee7785542","29":"af483dd641277caa","122":"f006b8598c2144cd","440":"02429c3d09607dc5"}[chunkId] + ".js";
};